export enum tabs {
	transactions = 'Transactions',
	NFT = 'NFT',
}
